import { combineReducers } from 'redux';
import checkoutPaymentReducer from '../areas/checkoutPayment/reducers';
import landingPageReducer from '../areas/landingPages/reducers';
import subscriptionsReducer from '../areas/subscriptions/reducers';
import basketReducer from './basketReducer';
import brandsReducer from './brandsReducer';
import configReducer from './configReducer';
import creditRedemptionReducer from './creditRedemptionReducer';
import cuisineReducer from './cuisineReducer';
import homepageFeaturedContentReducer from './homepageFeaturedContentReducer';
import homeReducer from './homeReducer';
import locationReducer from './locationReducer';
import mealCardReducer from './mealCardReducer';
import notificationReducer from './notificationReducer';
import orderReducer from './orderReducer';
import referralReducer from './referralReducer';
import requestReducer from './requestReducer';
import staticPageReducer from './staticPageReducer';
import userReducer from './userReducer';
import voteAreaReducer from './voteAreaReducer';
import voucherReducer from './voucherReducer';

export default combineReducers({
  basket: basketReducer,
  brands: brandsReducer,
  checkoutPayment: checkoutPaymentReducer,
  config: configReducer,
  creditRedemption: creditRedemptionReducer,
  cuisine: cuisineReducer,
  home: homeReducer,
  homepageFeaturedContent: homepageFeaturedContentReducer,
  landingPage: landingPageReducer,
  location: locationReducer,
  mealCard: mealCardReducer,
  notification: notificationReducer,
  order: orderReducer,
  referral: referralReducer,
  request: requestReducer,
  staticPage: staticPageReducer,
  subscriptions: subscriptionsReducer,
  user: userReducer,
  voteArea: voteAreaReducer,
  voucher: voucherReducer,
});
